import React, { useMemo } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { appTheme, useThemeColors, type ThemeColors } from '../../shared/theme';
import { centeredLabelText } from '../../shared/theme/sharedStyles';
import { MainLoader } from '../load-main/MainLoader';

interface LoadingStateProps {
  message?: string;
}

function createLoadingStateStyles(c: ThemeColors) {
  return StyleSheet.create({
    container: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
      padding: appTheme.spacing.xl,
    },
    text: {
      ...centeredLabelText,
      ...appTheme.typography.body,
      color: c.textSecondary,
      marginTop: appTheme.spacing.md,
    },
  });
}

export const LoadingState: React.FC<LoadingStateProps> = ({ message = 'Loading...' }) => {
  const colors = useThemeColors() ?? appTheme.colors;
  const styles = useMemo(() => createLoadingStateStyles(colors), [colors]);
  return (
    <View style={styles.container}>
      <MainLoader size={48} color={colors.primary} />
      <Text style={styles.text}>{message}</Text>
    </View>
  );
};
